import React from 'react';
import * as Icons from 'lucide-react';

export default function Icon({ name, className = 'h-5 w-5', ...rest }) {
  const Comp = Icons[name] || Icons.Circle;
  return <Comp className={className} {...rest} />;
}
